import React, { Component } from "react";

export default class ModAccordionsItem extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	
	render () {
		
		let item = this.props.item;
				
		if (item) {
						
		    return (
			    
			    <div className={'c-accordions__item ' + (this.state.open ? 'state-open' : '')}>
			    
					<a className="c-accordions__item__header" onClick={this.handleToggle} dangerouslySetInnerHTML={ {__html: item.heading + '<div class="c-accordions__item__header__icon"></div>'}}></a>
			    			    																											
					<div className="c-accordions__item__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
					
						<div className="c-accordions__item__body__inner" ref={e => (this.accordionBodyInner = e)}>
														
							<div className="scope-text" dangerouslySetInnerHTML={ {__html:item.text}}></div>
																
						</div>
						
					</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
